
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.99 0a.667.667 0 00-.656.675v7.329a.667.667 0 001.333 0V.676A.667.667 0 007.99.001zM4.664.814a.667.667 0 00-.3.077 8 8 0 107.273 0 .667.667 0 10-.607 1.187 6.667 6.667 0 11-6.06 0A.666.666 0 004.664.814z"}})])
          )
        }
      }
    